import { useMemo } from 'react'

import {
  BoxesIcon,
  BuildingIcon,
  CalendarIcon,
  ClipboardCheckIcon,
  HashIcon,
  LayersIcon,
  PlugIcon,
  ShieldCheckIcon,
  UserIcon,
  UsersIcon,
} from 'lucide-react'
import { ComboboxMulti } from 'twyne-new.ui'

import { useCustomReportStore } from '../store'
import { getCollectionGroupbyGroups } from '../utils/collectionGroupby'

import AddChartPopover from './AddChartPopover'
import ConfigField, { CONFIG_CONTROL_CLASS } from './ConfigField'
import { AddFilterButton, FilterByDropdowns, useFilterEditorState } from './FilterEditor'
import MetricEditor from './MetricEditor'
import SortEditor from './SortEditor'

const GROUPBY_ICONS = {
  'Full Time': CalendarIcon,
  'Unit Time': CalendarIcon,
  'Date Intervals': CalendarIcon,
  Traffic: UsersIcon,
  'User Session': UsersIcon,
  Request: UsersIcon,
  Midpath: LayersIcon,
  Entity: LayersIcon,
  Form: LayersIcon,
  CMS: LayersIcon,
  Integration: PlugIcon,
  Organization: BuildingIcon,
  Registration: ClipboardCheckIcon,
  Verifications: ShieldCheckIcon,
  Session: HashIcon,
  Consumer: UserIcon,
}

export default function ReportFilters() {
  const {
    config: { value, update },
  } = useCustomReportStore()

  const groupbyOptions = useMemo(
    () => getCollectionGroupbyGroups(value.collection).flatMap(([group, options]) => options.map(option => ({
      value: option.value,
      label: option.label,
      icon: GROUPBY_ICONS[group],
    }))),
    [value.collection],
  )
  const filters = value.filters || []

  const {
    activeEntities,
    hasPendingFilter,
    handleAddFilter,
    handleUpdateFilter,
    handleRemoveFilter,
  } = useFilterEditorState(filters, nextFilters => update({ filters: nextFilters }))

  return (
    <div className="mb-4 flex flex-wrap items-center gap-3">
      <ConfigField label="Group by" icon={BoxesIcon}>
        <ComboboxMulti
          className={CONFIG_CONTROL_CLASS}
          options={groupbyOptions}
          value={value.groupby || []}
          onChange={groupby => update({ groupby })}
          placeholder="Select group by"
          hideSelectAll
          maxCount={2}
          disabled={!groupbyOptions.length}
        />
      </ConfigField>
      <SortEditor
        collection={value.collection}
        groupby={value.groupby}
        metrics={value.metrics}
        sortby={value.sortby}
        onChange={sortby => update({ sortby })}
      />
      <MetricEditor
        collection={value.collection}
        metrics={value.metrics}
        onChange={metrics => update({ metrics })}
      />
      <FilterByDropdowns
        collection={value.collection}
        filters={filters}
        activeEntities={activeEntities}
        onUpdateFilter={handleUpdateFilter}
        onRemoveFilter={handleRemoveFilter}
      />
      <div className="ml-auto flex shrink-0 items-center gap-2">
        <AddFilterButton
          collection={value.collection}
          activeEntities={activeEntities}
          hasPendingFilter={hasPendingFilter}
          onAdd={handleAddFilter}
        />
        <AddChartPopover />
      </div>
    </div>
  )
}
